// turn number into short eg. 1000 to 1k
export const displayNumber = (num: number, decimals: number, minDecimals?: number) => {
  return Intl.NumberFormat('en-US', {
    notation: "compact",
    maximumFractionDigits: Math.max(decimals, minDecimals ?? 0),
    minimumFractionDigits: minDecimals ?? decimals,
    // minimumSignificantDigits: 2,
    // maximumSignificantDigits: 4
  }).format(num);
}

export function truncateStr(str: string = '', frontNum: number = 8, backNum: number = 8) {
  // Check if numbers are negative or zero
  // If negative, get absolute value. If zero, assign default value.
  const frontLimit = frontNum === 0 ? 8 : Math.abs(frontNum)
  const backLimit = backNum === 0 ? 8 : Math.abs(backNum)

  if (str.length > 0) {
    if (str.length > frontLimit + backLimit) {
      return `${str.substr(0, frontLimit)}...${str.substr(-backLimit)}`
    }
    return str
  }
  return ''
}